var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('span',{staticClass:"odd-boost-badge",class:[
        `odd-boost-badge--${_vm.size}`,
        _vm.showPercent ? 'odd-boost-badge--inline' : 'odd-boost-badge--corner'
      ],attrs:{"title":_vm.tooltip,"aria-label":"Boosted odds"}},[_c('span',{staticClass:"odd-boost-badge__pct"},[_vm._v("+"+_vm._s(_vm.formattedPercent)+"%")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }